import { zxcvbnOptions } from '../../Options';
export default (match) => {
    let warning = zxcvbnOptions.translations.warnings.keyPattern;
    if (match.turns === 1) {
        warning = zxcvbnOptions.translations.warnings.straightRow;
    }
    return {
        warning,
        suggestions: [zxcvbnOptions.translations.suggestions.longerKeyboardPattern],
    };
};
//# sourceMappingURL=feedback.js.map